<template v-bind="mlmViewTrackingId">
    <ms-search-box
        :isLoading="state.isLoading"
        :searchFilters="state.searchFilters"
        :totalCount="state.totalCount"
        @scrollToTop="scrollFromBelow"
        @openFilterModal="openFilterModal"
    />
    <div class="screen-xxl:grid screen-xxl:grid-cols-12 screen-l:gap-24">
        <ms-result-list-filter
            v-if="isScreenXXL"
            class="block col-span-3"
            :searchFilters="state.searchFilters"
            :locationLevels="locationLevels"
        />
        <div class="screen-l:col-span-9">
            <cs-filter-bar
                ref="filterBarComponent"
                :modelValue="searchParams.sort"
                :amountOfResults="getAmountOfResults()"
                :options="sortCriteriaOptions"
                showBookmarks
                :hasDot="hasDot"
                :amountOfFilter="getAmountOfFilter()"
                class="w-screen -ml-16 z-popup screen-m:w-full screen-m:ml-0 screen-m:mb-24"
                filterColor="bg-color-signatur-immo-100"
                @update:modelValue="onUpdateSort"
                @click:bookmark="onClickBookmark"
                @click:filter="openFilterModal"
            />
            <ms-result-list
                ref="resultListComponent"
                :data="resultListData"
                :items="state.items"
                :isLoading="state.isLoading"
                :privacyPoliceUrl="privacyPoliceUrl"
                :totalCount="state.totalCount"
                @scrollToTop="scrollFromAbove"
            />
        </div>
    </div>
    <div
        v-if="hasItems && state.floatingButtonIsVisible"
        class="fixed inset-x-0 bottom-64 z-popup screen-m:grid screen-m:grid-cols-[0_768px_1fr] screen-l:grid-cols-[1fr_970px_minmax(310px,1fr)] screen-xl:grid-cols-[minmax(160px,1fr)_970px_minmax(310px,1fr)] screen-xxl:grid-cols-[minmax(160px,1fr)_1140px_minmax(310px,1fr)]"
        data-test-id="floatingButton"
    >
        <div
            class="absolute bottom-0 transition-all duration-500 ease-in-out shadow rounded-normal"
            :class="[
                !shouldCollapseFloatingButton()
                    ? 'left-[50%] right-[50%] -translate-x-2/4 w-max'
                    : 'right-[0%] translate-x-0',
            ]"
        >
            <cs-primary-button
                :class="{ 'rounded-r-none': shouldCollapseFloatingButton() }"
                @click="openModal"
            >
                <template #icon> <ms-bell /></template>
                <template
                    v-if="!shouldCollapseFloatingButton()"
                    #default
                    >Suche abonnieren</template
                ></cs-primary-button
            >
        </div>
    </div>
    <ms-mail-agent-modal
        :isVisible="state.modalIsVisible"
        :trackingVariant="MailAgentTrackingVariant.STICKY"
        @closeModal="closeModal"
    />
    <ms-result-list-filter-modal
        :isVisible="isFilterModalVisible"
        :totalCount="state.totalCount"
        :searchFilters="state.searchFilters"
        :locationLevels="locationLevels"
        :isLoading="state.isLoading"
        @closeModal="closeFilterModal"
        @resultsButtonClicked="closeFilterModalAndScroll"
    />
    <ms-json-ld
        v-if="jsonLd"
        :json-ld="jsonLd"
    />
</template>
<script lang="ts" src="./HydratedRealEstateSearchList.ts" />
